/**
 * Returns an array of LineItem analytics DTOs.
 *
 * The LineItem attributes should be sourced from CartItemResource and
 * require that the product is embedded.
 */
export const mapToAnalyticsData = (items) => {
  return items.map((item) => ({
    productId: item.product.id,
    sku: item.product.sku,
    productName: item.name,
    price: item.unit_price,
    quantity: item.quantity,
    url: item.product.url,
    image: item.product.featured_image_url,
  }))
}
